import { Building2 } from 'lucide-react';

/**
 * Every attendant screen is facility-scoped. A staff member with no assignment
 * — or an owner on an estate with no facilities yet — has nothing to act on.
 *
 * This exists because three screens each early-returned out of their loader
 * before clearing `loading`, leaving a spinner that never resolved. Rendering
 * a shared, explicit state is harder to get wrong than remembering to unset a
 * flag on every guard clause.
 */
export default function NoFacility({ hasAnyFacility }) {
  return (
    <div className="mx-auto max-w-lg px-4 py-16 text-center">
      <Building2 className="mx-auto h-8 w-8 text-brand-300" aria-hidden="true" />
      <p className="mt-3 text-sm font-bold text-slate-900">
        {hasAnyFacility ? 'No facility selected' : 'No facilities yet'}
      </p>
      <p className="mt-1 text-sm text-slate-500">
        {hasAnyFacility
          ? 'Pick a facility from the switcher above to start your shift.'
          : 'Once a facility is added you will be able to work it from here.'}
      </p>
    </div>
  );
}
